"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.dataCy = void 0;
var _Step = require("@mui/material/Step");
var _StepConnector = _interopRequireDefault(require("@mui/material/StepConnector"));
var _styles = require("@mui/styles");
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var dataCy = exports.dataCy = "StepConnector";
var styles = function styles(theme) {
  return {
    vertical: {
      padding: 0,
      marginLeft: 5
    },
    alternativeLabel: {
      top: 5,
      left: 'calc(-50% + 14px)',
      right: 'calc(50% + 14px)'
    },
    line: {
      borderColor: theme.palette.inactive.main,
      borderWidth: 0,
      borderLeftWidth: 2,
      borderStyle: 'dashed'
    },
    active: {
      '& $line': {
        borderColor: theme.palette.draft.main,
        borderStyle: 'solid'
      }
    },
    completed: {
      '& $line': {
        borderColor: theme.palette.draft.main,
        borderStyle: 'solid'
      }
    },
    lineVertical: {
      minHeight: 32
    },
    lineHorizontal: {
      borderTopWidth: 2
    }
  };
};
var StepConnector = function StepConnector(_ref) {
  var classes = _ref.classes;
  var _useStepContext = (0, _Step.useStepContext)(),
    active = _useStepContext.active,
    completed = _useStepContext.completed;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_StepConnector["default"], {
    "data-cy": dataCy,
    "data-cy-state": active ? "active" : completed ? "completed" : "draft",
    classes: classes
  });
};
var _default = exports["default"] = (0, _styles.withStyles)(styles)(StepConnector);